import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { momentParse } from '../../utils/time';
import MaterialLink from '../material-link';
import Markdown from '../markdown';

const useStyles = makeStyles((theme) => ({
  meta: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: '#333'
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(0.5)
  },
  avatar: {
    height: 18,
    width: 18
  },
  displayName: {
    marginLeft: theme.spacing(0.5)
  },
  body: {
  },
  subjectLink: {
    color: '#000'
  },
  commentCount: {
    marginLeft: theme.spacing(0.5)
  }
}));

const GroupPost = ({ post, group }) => {
  const classes = useStyles();

  if (!post) {
    return null;
  }

  const createdAt = post ? momentParse(post.createdAt) : null;
  return (
    <div className={classes.post}>
      <Typography variant="h3">
        <MaterialLink
          href="/groups/[slug]/posts/[id]"
          as={`/groups/${group.slug}/posts/${post.id}`}
          className={classes.subjectLink}
        >
          {post.subject}
        </MaterialLink>
      </Typography>
      <div className={classes.body}>
        <Markdown>{post.body}</Markdown>
      </div>
      <div className={classes.meta}>
        <span className={classes.metaMessage}>
          Posted{' '}
          <time
            className={classes.createdAt}
            dateTime={createdAt.toString()}
            title={createdAt.format('dddd, MMMM Do, YYYY h:mm a')}
          >
            <MaterialLink
              href="/groups/[slug]/posts/[id]"
              as={`/groups/${group.slug}/posts/${post.id}`}
            >
              {createdAt.fromNow()}
            </MaterialLink>
          </time>
          {' by '}
        </span>
        <span className={classes.user}>
          <MaterialLink
            href="/people/[username]"
            as={`/people/${post.user.username}`}
            className={classes.avatarLink}
          >
            <Avatar
              alt={post.user.displayName}
              src={post.user.avatar.small.url}
              className={classes.avatar}
            />
          </MaterialLink>
          <MaterialLink
            href="/people/[username]"
            as={`/people/${post.user.username}`}
            className={classes.displayName}
          >
            {post.user.displayName}
          </MaterialLink>
        </span>
        <span className={classes.commentCount}>
          &ndash;{' '}
          <MaterialLink
            href="/groups/[slug]/posts/[id]"
            as={`/groups/${group.slug}/posts/${post.id}`}
          >
            {post.commentCount === 0 ? 'no' : post.commentCount}
            {' '}
            comment{post.commentCount !== 1 ? 's' : ''}
          </MaterialLink>
        </span>
      </div>
    </div>
  );
};

GroupPost.propTypes = {
  post: PropTypes.object,
  group: PropTypes.object
};

export default GroupPost;
